import React from "react"
import { graphql } from "gatsby"
import { Link } from "../../../../plugins/gatsby-plugin-atollon"
import parse from "html-react-parser"
import StructuredText from "../custom-structured-text-renderer"
import { Arrow } from "../../icons"

const ThankYou = ({ title, richContent, link, subtitle }) => {
  return (
    <section className="thank-you">
      <div className="thank-you__inner">
        <div className='thank-you__wrapper'>
          <div className='thank-you__left'>
            {title && <span className='btn btn--orange'>{parse(title)}</span>}
          </div>
          <div className='thank-you__right'>
            {title && <h2>{parse(title)}</h2>}
            {subtitle && <h3>{parse(subtitle)}</h3>}

            <StructuredText data={richContent} />
            {
              link?.length > 0 &&
              <Link
                to={link[0]?.link[0].externalLink ? link[0]?.link[0].externalLink : link[0]?.link[0].internalLink.permalink}>
                <Arrow/>
              </Link>
            }
          </div>
        </div>
      </div>
    </section>
  )
}

export default ThankYou

export const query = graphql`
fragment ThankYouProps on DatoCmsThankYou {
  ... on DatoCmsThankYou {
    id
    title
    subtitle
    richContent {
      value
    }
    link {
      ...LinkWithoutTitleProps
    }
  }
}
`